(function () {
  'use strict';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }
  var moneyFormat = (window.Medix && window.Medix.moneyFormat) || '${{amount}}';

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('.site-header');
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // One-time / subscribe price toggle on product grids
  document.querySelectorAll('[data-price-toggle]').forEach(function (wrap) {
    var section = wrap.closest('[data-section]') || document;
    var pct = parseFloat(wrap.getAttribute('data-discount')) || 0;
    var buttons = wrap.querySelectorAll('button');
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var sub = b.getAttribute('data-mode') === 'sub';
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        section.querySelectorAll('[data-card-price]').forEach(function (el) {
          var base = parseInt(el.getAttribute('data-card-price'), 10);
          el.textContent = money(sub ? Math.round(base * (100 - pct) / 100) : base, moneyFormat);
        });
      });
    });
  });

  // Product page
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('script[data-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var addBtn = form.querySelector('[data-add]');
    var selects = form.querySelectorAll('[data-option]');

    function currentVariant() {
      if (!selects.length) return variants[0];
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }
    function currentPlan() {
      var r = form.querySelector('input[name="purchase"]:checked');
      return r && r.value !== 'once' ? r.value : '';
    }
    function update() {
      var v = currentVariant();
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); } return; }
      idInput.value = v.id;
      var plan = currentPlan();
      if (planInput) planInput.value = plan;
      var price = v.price;
      if (plan && v.plans && v.plans[plan] != null) price = v.plans[plan];
      if (priceEl) priceEl.textContent = money(price, moneyFormat);
      form.querySelectorAll('[data-plan-price]').forEach(function (el) {
        var p = el.getAttribute('data-plan-price');
        el.textContent = money(p === 'once' ? v.price : (v.plans && v.plans[p] != null ? v.plans[p] : v.price), moneyFormat);
      });
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout');
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    form.querySelectorAll('input[name="purchase"]').forEach(function (r) { r.addEventListener('change', update); });
    update();
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var min = parseInt(input.getAttribute('min') || '0', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = t.getAttribute('data-alt') || '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
  });

  // Quiz
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var result = quiz.querySelector('[data-quiz-result]');
    var bar = quiz.querySelector('[data-quiz-bar]');
    var count = quiz.querySelector('[data-quiz-count]');
    var scores = {};
    var i = 0;
    function show(n) {
      steps.forEach(function (s, k) { s.hidden = k !== n; });
      if (bar) bar.style.width = ((n + 1) / (steps.length + 1) * 100) + '%';
      if (count) count.textContent = (n + 1) + ' / ' + steps.length;
    }
    function finish() {
      steps.forEach(function (s) { s.hidden = true; });
      if (bar) bar.style.width = '100%';
      if (count) count.textContent = '';
      var best = null;
      Object.keys(scores).forEach(function (k) { if (best === null || scores[k] > scores[best]) best = k; });
      quiz.querySelectorAll('[data-quiz-outcome]').forEach(function (o) {
        o.hidden = o.getAttribute('data-quiz-outcome') !== best;
      });
      result.hidden = false;
    }
    quiz.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var need = btn.getAttribute('data-quiz-answer');
        var w = parseInt(btn.getAttribute('data-weight') || '1', 10);
        scores[need] = (scores[need] || 0) + w;
        i += 1;
        if (i >= steps.length) finish(); else show(i);
      });
    });
    var restart = quiz.querySelector('[data-quiz-restart]');
    if (restart) restart.addEventListener('click', function () { scores = {}; i = 0; result.hidden = true; show(0); });
    if (steps.length) show(0);
  });
})();
